// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--Ft-32","video-container":"_93444fe79c--video-container--2oByN","icon":"_93444fe79c--icon--1go_I"};